import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
// import {Button} from "react-bootstrap";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Redirect } from "react-router";
import fontb from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
import logo1 from "../../assets/img/etela.png"
import logo2 from "../../assets/img/ihcs.png"
import { Row ,Col} from 'react-bootstrap';
import Grid from '@material-ui/core/Grid';
import { createMuiTheme, ThemeProvider,StylesProvider } from '@material-ui/core/styles';
// import { , ThemeProvider } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import { jssPreset } from "@material-ui/core/styles";
import RTL from "layouts/Dashboard";
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme4 = createMuiTheme({
  typography: { useNextVariants: true },
  direction: "rtl"
});

let theme2 = createMuiTheme();

theme2.typography.h3 = {
  fontSize: '1.2rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
  [theme2.breakpoints.up('md')]: {
    fontSize: '2.5rem',
  },
};


let fontConfig = {

  file: [
    {
      fontFamily: 'Bangers',
      fontStyle:  'normal',
      fontWeight: 400,
      // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
      file: fontb,
      fontType: 'truetype',
      fileLocal: 'Bangers Regular'
    },
    
  
  ]
}
 class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // UserName: "",
      Password: "",
      Password2:"",
      Email:"",
      token: "",
      ActivationToken:props.location.search,
      signup:false,
      TranseferLoginPage:null,
      classes: makeStyles((theme) => ({
        paper: {
          marginTop: theme.spacing(8),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "rgb(179,7,83)",
        },
        avatar: {
          color: "#3f51b5",
          // margin: theme.spacing(1),
          // marginLeft:'1000px',
          // backgroundColor: '#f44336',
        },
        form: {
          width: "100%", // Fix IE 11 issue.
          marginTop: theme.spacing(1),
        },
        submit: {
          margin: theme.spacing(3, 0, 2),
        },
      })), 
    };
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword1 = this.handleChangePassword1.bind(this);
    this.handleChangePassword2 = this.handleChangePassword2.bind(this);
  }

  handleChangeEmail(event) {
    this.setState({ Email: event.target.value });
  }

  handleChangePassword1(event) {
    this.setState({ Password: event.target.value });
  }

  handleChangePassword2(event) {
    this.setState({ Password2: event.target.value });
  }

  render() {
   
    return (
      // <BrowserView>
      <StylesProvider jss={jss}>
      <ThemeProvider theme={theme4}>

     
      <div style={{  display: 'flex', justifyContent: "center",marginTop:'5%'}}>
        <div style={{width:"60%",border:'1px solid black',borderRadius:"1%"}}>
      <Grid Container fluid  style={{justifyContent: 'row', display: "flex",backgroundColor: "rgb(44,71,76)" ,width:"100%"}}>
      <Grid item xs={4} sm={4} md={4} lg={4} >
      <img src={logo1} style={{width:'100%'}}/>
        </Grid>
        {/* <div style={{width:"15%",height:"10vh"}}> */}
        <Grid item xs={12} sm={12} md={12} lg={12} >
    <ThemeProvider theme={theme2} >
      <Typography variant="h3" style={{height:"30%", textAlign:"center", fontFamily:'Bangers',marginTop:"6%",color:"rgb(255,255,255)"}}> سامانه تحلیل مقالات علمی
</Typography>
    </ThemeProvider>
      
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} >
        <img  src={logo2} style={{width:'100%'}}/>
        </Grid>

        
          </Grid>
          <div style={{height:".001%",border:'1px solid black'}}>

          </div>
          <ThemeProvider theme={theme2} >
      <Typography variant="h3" style={{ textAlign:"center", fontFamily:'Bangers',marginTop:"5%"}}>               ثبت نام در سامانه
</Typography>
    </ThemeProvider>
        
      <Container  component="main" maxWidth="xs" style={{height:'auto'}}>
        <CssBaseline />
        <Button
              fullWidth
              
              className="button"
              style={{fontFamily:'Bangers',fontSize:20,width:"4%" ,backgroundColor: "rgb(44,71,76)",position: 'fixed', top: 0,
              left: 0,borderRadius:"5px",color:"rgb(255,255,255)" }}
              onClick={() => this.back()}
            >
              بازگشت  
            </Button> 
        <div className={this.state.classes.paper} style={{marginTop:"10%",height:'auto'}}>
          
       
          <form className={this.state.classes.form} noValidate >
            {/* <TextField 
            required minLength={1}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="نام کاربری"
              name="email"
              autoComplete="email"
              onChange={this.handleChange}
              autoFocus
            /> */}
                {/* <TextField 
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="ایمیل"
              name="email"
              autoComplete="email"
              onChange={this.handleChangeEmail}
              autoFocus
            /> */}
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="رمز عبور جدید"
              type="password"
              id="password"
              onChange={this.handleChangePassword1}
              autoComplete="current-password"
            />
             <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="تکرار رمز عبور جدید"
              type="password"
              id="password"
              onChange={this.handleChangePassword2}
              autoComplete="current-password"
            />
           
            <Button
              fullWidth
              
              className="button"
              style={{fontFamily:'Bangers',fontSize:20 ,backgroundColor: "rgb(44,71,76)",color:"rgb(255,255,255)" }}
              onClick={() => this.sendResetPassData()}
            >
              تغییر رمز  
            </Button>
          
            <div>{this.SignUpcheck()}</div>
            <div>{this.check22()}</div>
            {this.state.back ?  <Redirect
          to={{
            pathname: "/",
           
          }}
        /> :null}
          </form>
        </div>
        <Box mt={8}>{/*<Copyright/>*/}</Box>
      </Container>
      </div>
      </div>
      </ThemeProvider>
    </StylesProvider>
      
    );
  }
  SignUp(){
    this.setState({
      signup:true
    })
  }
  back(){
    this.setState({
      back:true
    })

  }
  SignUpcheck(){
    if (this.state.signup){

      return (
        // <BrowserRouter>
        <Redirect
          to={{
	      //            pathname: "http://conalysis.ihcs.ac.ir:8080/signup",
	                  pathname: "http://conalysis.ihcs.ac.ir:8080/signup",

            state: {
              token: this.state.token,
              UserName: this.state.UserName,
            },
          }}
        />
        // </BrowserRouter>
      );
  
    }


  }
  ForgetPassword(){
    return (
      // <BrowserRouter>
      <Redirect
        to={{
          pathname: "/forgetpassword",
          state: {
            token: this.state.token,
            UserName: this.state.UserName,
          },
        }}
      />
      // </BrowserRouter>
    );


  }
  check22() {
    if (this.state.token) {
      // console.log("entered");
      return (
        // <BrowserRouter>
        <Redirect
          to={{
            pathname: "/dashboard/LDA",
            state: {
              token: this.state.token,
              UserName: this.state.UserName,
            },
          }}
        />
        // </BrowserRouter>
      );
    }
  }

  sendResetPassData() {
    // if(!this.state.Email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/)){
    //   alert("ایمیل را با فرمت درست وارد کنید");
    // }
    if(this.state.Password!==this.state.Password2){
      alert("رمزهای وارد شده یکسان نمی باشند");

    }
    else if(!this.state.Password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/)){
      alert(".رمز باید شامل حداقل ۸ کاراکتر انگلیسی باشد که حداقل یک حرف وحداقل یک عدد داشته باشد");

    }
    else{
     
      const user= this.state.ActivationToken.split('?');
//      fetch("http://conalysis.ihcs.ac.ir:8080/reset_pasword", {

	fetch("http://conalysis.ihcs.ac.ir:8080/reset_pasword", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // Email: this.state.Email,
          token:user[2],
          email:user[1],
          Password: this.state.Password,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if(responseJson.status=='block'){
            // alter("username or password is wrong") 
            alert("نام کابری یا رمز عبور اشتباه است")
          }
          else{
  
            this.setState({
              token: responseJson.token,
            });
            alert("رمز با موفقیت تغییر یافت")
          }
          // console.log(responseJson);
         
          // window.location.href="/dashboard";
          // return (<Link to="/dashboard"/>);
          // alert(responseJson);
        })
        .catch((error) => { 
          console.log(error);
        });


    }
    
   
  }
}
export default ReactFontFace(ResetPasswordPage, fontConfig);
